import { useCallback, useEffect, useRef, useState } from 'react';

const ACTIVITY = ['mousemove', 'keydown', 'pointerdown', 'touchstart'] as const;

/** True once nobody has touched the board for a while; any activity brings the controls back. */
export function useIdleHidden(delayMs = 3000): { hidden: boolean; show: () => void } {
  const [hidden, setHidden] = useState(false);
  const timer = useRef<number | undefined>(undefined);

  const arm = useCallback(() => {
    window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => setHidden(true), delayMs);
  }, [delayMs]);

  const show = useCallback(() => {
    setHidden(false);
    arm();
  }, [arm]);

  useEffect(() => {
    arm();
    for (const type of ACTIVITY) document.addEventListener(type, show, { passive: true });
    return () => {
      window.clearTimeout(timer.current);
      for (const type of ACTIVITY) document.removeEventListener(type, show);
    };
  }, [arm, show]);

  return { hidden, show };
}
